import React from 'react';
import { Modal, Box, Typography, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import CollectionModalForm from './CollectionModalForm';
import { useAddCollectionMutation } from "store/services/collectionApi";
import { toast } from "react-toastify";

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '70%',
  transform: 'translate(-50%, -50%)',
  width: '40%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  maxHeight: '90vh',
  overflowY: 'auto',
};

const CollectionModal = ({ open, onClose, shipment }) => {
  const [addCollection, { isLoading }] = useAddCollectionMutation();
  if (!shipment) return null;
  const handleSubmit = async (data) => {
    try {
      await addCollection(data).unwrap();
      toast.success("Collection successfully created!");
      onClose();
    } catch (err) {
      toast.error(
        err?.data?.message || err?.message || "Couldn't create collection!"
      );
    }
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="collection-modal-title">
      <Box sx={modalStyle}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography id="collection-modal-title" variant="h6" component="h2">
            Accept this Shipment ?
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Box>
        <CollectionModalForm
          isBusy={isLoading}
          fulfillmentDetail={{
            shipmentId: shipment, 
            driverId: shipment.assignedDriver, 
            vehicle_id: shipment.assignedVehicle,
          }}
          onSubmit={handleSubmit}
        />
      </Box>
    </Modal>
  );
};

export default CollectionModal;
